import { render, staticRenderFns } from "./RecommenderReward.vue?vue&type=template&id=410e0f43&scoped=true"
import script from "./RecommenderReward.vue?vue&type=script&lang=js"
export * from "./RecommenderReward.vue?vue&type=script&lang=js"
import style0 from "./RecommenderReward.vue?vue&type=style&index=0&id=410e0f43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410e0f43",
  null
  
)

export default component.exports